import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Tag,
  Drawer,
  Space,
  Button,
  Input,
  Card,
  Col,
  Row,
  Statistic,
  DatePicker,
  Popconfirm,
  Select,
  AutoComplete,
  Modal,
  Radio,
  Tooltip,
  Typography,
} from "antd";

import { useParams, useHistory, useLocation } from "react-router-dom";

import {
  EditOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  DeleteTwoTone,
  LoadingOutlined,
  SearchOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import {
  getAllApprovals,
  getApprovals,
  updateApproval,
  getApprovalStats,
  updateVars,
  removeApprovalTask,
  setOnHold,
  resetApproval,
  saveApproval,
  saveDropdownList
} from "../../../redux/actions/approval";

import { getOrgMembers } from "../../../redux/actions/organizationAction";

import { getAutomationBuild } from "../../../redux/actions/logs";
import { uuid4 } from "@sentry/utils";

import moment from "moment";
import { notify } from "../../../components/Snack";
import statsApproved from "../../../images/stats-approved.png";
import statsRejected from "../../../images/stats-rejected.png";
import statsInProgress from "../../../images/stats-inprogress.png";
import Loader from "../../../components/loader";
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Text } = Typography;

const options = [
  {
    value: "Invoice No",
  },
  {
    value: "Vendor Name",
  },
  {
    value: "Invoice Date",
  },
];

const Approval = () => {
  const history = useHistory();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [_approvals, _setApprovals] = useState([]);
  const [_currentApproval, _setCurrentApproval] = useState(null);
  const [_buildDetails, _setBuildDetails] = useState(null);
  const [_variables, _setVariables] = useState({});
  const [_allVariables, _setAllVariables] = useState({});
  const [_urls, _setUrls] = useState([]);
  const [remarks, setRemarks] = useState([]);
  let [_tableData, _setTableData] = useState([]);
  let [_tableColumns, _setTableColumns] = useState([]);
  const [_remarksColumns, _setRemarksColumns] = useState([]);
  const [_remarksData, _setRemarksData] = useState([]);
  const [tableVariable, setTableVariable] = useState(null);
  const [filters, setFilters] = useState(["incomplete"]);
  const [showTable, setShowTable] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [varName, setVarName] = useState("");

  const [nameValue, setNameValue] = useState("");
  const [BPCodeValue, setBPCodeValue] = useState("");
  const [GLAccountNameValue, setGLAccountNameValue] = useState("");
  const [GLCodeValue, setGLCodeValue] = useState("");
  const [deptValue, setDeptValue] = useState("");
  const [divValue, setDivValue] = useState("");
  const [projectCodeValue, setProjectCodeValue] = useState("");

  const [varValue, setVarValue] = useState("");
  const [dialog, showDialog] = useState(false);
  const [dialogOne, showDialogOne] = useState(false);
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const [approvedCount, setApprovedCount] = useState(0);
  const [inProgressCount, setInProgressCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [isLoadingStats, setIsLoadingStats] = useState(false);
  const [queryName, setQueryName] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [adminAction, setAdminAction] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const [isOnHold, setIsOnHold] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDynamicModalOpen, setIsDynamicModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  const [overRideOptions, setOverRideOptions] = useState([]);
  const [overRideUser, setOverRideUser] = useState("");
  const [isOpeningDrawer, setIsOpeningDrawer] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [isRejectUserModalOpen, setIsRejectUserModalOpen] = useState(false);
  const [reseting, setIsReseting] = useState(false);
  const [newRemarks, setNewRemarks] = useState({});
  const [userDropDown, setUserDropDown] = useState([]);
  const [defaultuserDropDown, setDefaultUserDropDown] = useState([]);
  const [reviewText, setReviewText] = useState("");
  const [validationCheck, setValidationCheck] = useState(false);
  const [emptyFields, setEmptyFields] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrganization
  );
  const currentUser = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );

  const approvals = useSelector((state) => state.approvalReducer.approvals);
  const approvalDropdownList = useSelector((state) => state.approvalReducer.approvalDropdown);
  const glDropdownList = useSelector((state) => state.approvalReducer.glDropdown);
  const automationBuildLog = useSelector(
    (state) => state.logsReducer.automationBuildLog
  );

  const isLoadingApprovalList = useSelector(
    (state) => state.approvalReducer.isLoadingApprovalList
  );
  const user = useSelector((state) => state?.userReducer?.user);
  const orgusers = useSelector(
    (state) => state?.organizationReducer?.organizationPeople
  );

  useEffect(() => {
    if (_currentApproval) {
      let _defaultUsers = _currentApproval.approvers.list;
      let _u = orgusers.map((i) => {
        return {
          value: i.email,
          label: i.email,
          disabled: _defaultUsers.indexOf(i.email) >= 0,
        };
      });

      setUserDropDown(_u);
      setDefaultUserDropDown([..._defaultUsers]);
    }
  }, [orgusers, _currentApproval]);

  useEffect(() => {
    getApprovalList();
  }, [location.search]);

  useEffect(() => {
    // window.history.pushState(null, "", "/dashboard/approvals");
    _setApprovals(approvals);
  }, [approvals]);

  useEffect(() => {
    if (_currentApproval && automationBuildLog) {
      _setButtonDisabled(_currentApproval);
      _setBuildDetails(automationBuildLog);
      _setAllVariables(automationBuildLog?.variables);
      _setVariablesAndFilterURLs(automationBuildLog?.variables);
      dispatch(
        getOrgMembers(
          _currentApproval?.automation_build?.draft_skill?.organizationId
        )
      );
      // dispatch(getOrgMembers(116))
    }
  }, [automationBuildLog, _currentApproval]);

  const getApprovalList = () => {
    const queryParams = new URLSearchParams(location.search);
    const approval_id = queryParams.get("a_id");
    const skill_id = queryParams.get("skill_id");
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    startDate.setDate(startDate.getDate() - 7);
    let _s = moment(startDate);
    let _e = moment(endDate);
    let _parsedDates = [startDate, endDate];
    setDates([_s, _e]);

    formatData(_parsedDates);
    if (skill_id && approval_id) {
      setFilters(["incomplete", "approved", "rejected"]);
      dispatch(getApprovals(skill_id, {}, approval_id));
    } else {
      dispatch(getAllApprovals());
    }
  };
  const _setButtonDisabled = (approval) => {
    let status = false;
    if (typeof approval?.approvers?.meta?.[user?.email] == "boolean") {
      status = true;
    }
    setButtonDisabled(status);
  };
  const showDrawer = (obj) => {
    setRemarksData(obj?.approvers?.remarks);
    _setCurrentApproval(obj);
    // setRemarks(obj.remarks);
    setRemarks(obj?.approvers?.remarks ? obj?.approvers?.remarks : []);
    setIsOpeningDrawer(false);
    setOpen(true);
  };
  const setRemarksData = (remark) => {
    let _coloumns = [
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        title: "Last updated",
        dataIndex: "updateAt",
        key: "updateAt",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
      },
    ];
    _setRemarksColumns(_coloumns);
    _setRemarksData(remark);
  };
  const checkIsAdmin = (obj) => {
    let _approverlist = [];

    let approvalOrg = obj?.automation_build?.draft_skill?.organizationId;
    if (
      userRole?.id == approvalOrg &&
      (userRole?.isAdmin || currentUser?.role_id == "2")
    ) {
      // if (obj?.approvers?.kind == "serial") {
      //   let _tempMeta = Object.keys(obj?.approvers?.meta);
      //   _tempMeta.map((item) => {
      //     if (!obj?.approvers?.meta[item]) {
      //       let _obj = {
      //         label: item,
      //         value: item,
      //       };
      //       _approverlist.push(_obj);
      //     }
      //   });
      // } else {
      //   obj?.approvers?.list?.map((a) => {
      //     if (!obj?.approvers?.meta.hasOwnProperty(a)) {
      //       let _obj = {
      //         label: a,
      //         value: a,
      //       };
      //       _approverlist.push(_obj);
      //     }
      //   });
      // }
      setIsAdmin(true);
      obj?.approvers?.list?.map((a) => {
        let _obj = {
          label: a,
          value: a,
        };
        _approverlist.push(_obj);
      });
      setOverRideOptions(_approverlist);
    } else {
      setIsAdmin(false);
    }
  };

  const addVariable = () => {
    let uuid = uuid4();
    let parentId = _currentApproval.approvers.actions[0];
    let _var = {
      id: uuid,
      name: varName,
      label: varName,
      value: varValue,
      parent: parentId,
      dataType: "string",
      editable: true,
      reviewVar: true,
      defaultValue: varValue,
      reviewVariable: true,
    };
    _allVariables[uuid] = { ..._var };
    _variables[uuid] = { ..._var };
    _setAllVariables({ ..._allVariables });
    _setVariables({ ..._variables });
    dispatch(updateVars(_currentApproval.build_id, _allVariables));
  };

  const handleDelete = (record) => {
    console.log(record);
    let newData = _tableData.filter((i) => i.key !== record.key);
    _allVariables[tableVariable] = {
      ..._allVariables[tableVariable],
      value: [{ page_id: 1, tableData: newData }],
    };
    _setAllVariables({ ..._allVariables });
    _setTableData(newData);
    dispatch(updateVars(_currentApproval.build_id, _allVariables));
  };

  const addTableRow = () => {
    const _len = _tableData.length + 1;
    let obj = { ..._tableData[0] };
    Object.keys(obj).forEach((key) => {
      obj[key] = "";
    });
    obj["key"] = `ocr_table_data_${_len}`;
    _tableData.push(obj);
    _allVariables[tableVariable] = {
      ..._allVariables[tableVariable],
      value: [{ page_id: 1, tableData: _tableData }],
    };
    _setAllVariables({ ..._allVariables });
    _setTableData(_tableData);
    setShowTable(false);
    dispatch(updateVars(_currentApproval.build_id, _allVariables));
    setTimeout(() => {
      setShowTable(true);
    }, 3000);
  };

  const removeVariable = (uuid) => {
    delete _allVariables[uuid];
    delete _variables[uuid];
    _setAllVariables({ ..._allVariables });
    _setVariables({ ..._variables });
    dispatch(updateVars(_currentApproval.build_id, _allVariables));
  };

  const _setVariablesAndFilterURLs = (variables) => {
    let urls = [];
    Object.keys(variables || []).forEach((i) => {
      const e = variables[i];
      const urlRegex =
        /\bhttps?:\/\/(?:www\.)?[\w-]+(\.[a-z]{2,6}){1,2}(?:\/[\w-./?%&=]*)?\b/g;
      if (typeof e.value == "string" && e?.value.match(urlRegex)) {
        urls.push(e?.value);
      }
    });

    let _filteredVariables = {};
    let tableDataTemp;

    Object.keys(variables || []).map((i) => {
      if (
        _currentApproval.approvers.actions.includes(variables[i]?.parent) ||
        _currentApproval.approvers.actions.includes(variables[i]?.actionId)
        // variables[i]?.id == "872386ac-89a8-4b26-867d-f078073d6260" ||
        // urls.includes(i)
      ) {
        if (variables[i]?.type == "list" || variables[i]?.type == "dataTable") {
          
          approvalDropdownList?.forEach(obj => {
            let temp = Object.values(obj)
            temp[0] = `${obj.name}_${obj.bp_code}_${obj.gl_code}`  // Concatenating name, bp_code, and gl_code as the first index
            // Check if the object (temp) is already in variables[i]?.value
            temp.splice(1, 1);
            const isPresent = variables[i]?.value.some(existingValue => existingValue[0] === temp[0]);

            // Only push if not already present
            if (!isPresent) {
                variables[i]?.value.push(temp);
            }
          });
          _filteredVariables[i] = variables[i];
        } else if (
          typeof variables[i]?.value == "string" ||
          typeof variables[i]?.type == "number"
        ) {
          _filteredVariables[i] = variables[i];
        } else if (variables[i]?.name.includes("tableData")) {
          setTableVariable(variables[i]?.id);
          let temp = variables[i]?.value;
          if (typeof variables[i]?.value == "string") {
            temp = JSON.parse(variables[i]?.value);
          }
          let columns = [];
          let tableData = [];
          if (temp && temp.length > 0) {
            [{ tableData }] = temp;
            if (tableData && tableData.length > 0 && tableData[0]) {
              columns = Object.keys(tableData[0])
                .filter((i) => i !== "key")
                .map((i) => {
                  return {
                    title: i,
                    width: 100,
                    dataIndex: i,
                    render: (text) => (
                      <div style={{ fontSize: 12, fontWeight: 100 }}>
                        {text}
                      </div>
                    ),
                  };
                });
            }
          }

          columns = [...columns];
          tableData = tableData.map((i, index) => {
            return {
              key: `ocr_table_data_${uuid4()}`,
              ...i,
            };
          });
          _setTableColumns(columns);
          _setTableData(tableData);
          tableDataTemp = tableData;
        }
      }
    });

    Object.keys(variables || []).map((i) => {
      if (
        variables[i]?.type == "dataTable" &&
        variables[i]?.defaultValue?.length > 0
      ) {
        _setTableData(tableDataTemp);
      }
    });
    _setUrls(urls);
    _setVariables(_filteredVariables);
  };

  const variableOnChange = (e, id, list = false) => {
    if (list) {
      _variables[id] = { ..._variables[id], defaultValue: e };
      _allVariables[id] = { ..._allVariables[id], defaultValue: e };
    } else {
      _variables[id] = { ..._variables[id], value: e.target.value };
      _allVariables[id] = { ..._allVariables[id], value: e.target.value };
    }
    _setAllVariables({ ..._allVariables });
    _setVariables(_variables);
  };

  const variableOnChangeDateSelected = (e, id, type) => {
    const selectedDate = type == "invoice_due_date" ? moment(e).format('MMM DD, YYYY') :  moment(e).format('MM/DD/YY')
    _variables[id] = { ..._variables[id], value: selectedDate };
    _allVariables[id] = { ..._allVariables[id], value: selectedDate};
    _variables[id] = { ..._variables[id], defaultValue: selectedDate };
    _allVariables[id] = { ..._allVariables[id], defaultValue: selectedDate };
    _setAllVariables({ ..._allVariables });
    _setVariables(_variables);
  };

  const variableOnChangeDataTable = (
    e,
    variableFilterData,
    id,
    list = false
  ) => {
    let div;
    let dept;
    // let blCode;
    // let AccountName;
    let ProjectCode;
    variableFilterData?.map((i, index) => {
      if (i[0] == e) {
        div = i[5];
        ProjectCode = i[6];
        dept = i[4];
        // blCode = i[2];
        // AccountName = i[3];
      }
    });

    const _newTable = _tableData.map((item, index) => {
      let _obj = {};
      _obj["DIV"] = div;
      _obj["Dept"] = dept;
      // _obj["GLCode"] = blCode;
      // _obj["GLAccountName"] = AccountName;
      _obj["ProjectCode"] = ProjectCode;
      return { ...item, ..._obj };
    });
    _setTableData(_newTable);

    _variables[id] = { ..._variables[id], defaultValue: e };
    _allVariables[id] = { ..._allVariables[id], defaultValue: e };

    _allVariables[tableVariable] = {
      ..._allVariables[tableVariable],
      value: [{ page_id: 1, tableData: _newTable }],
    };

    _setAllVariables({ ..._allVariables });
    _setVariables(_variables);
  };

  const glCodeOnChangeDataTable = (
    e,
    id
  ) => {

    _variables[id] = { ..._variables[id], gl_code: e };
    _allVariables[id] = { ..._allVariables[id], gl_code: e };    
    
    const _newTable = _tableData.map((item, index) => {
      let _obj = {};
     
      _obj["GLCode"] = e.split(" - ")[0];
      _obj["GLAccountName"] = e.split(" - ")[1];
     
      return { ...item, ..._obj };
    });
    _setTableData(_newTable);

    _allVariables[tableVariable] = {
      ..._allVariables[tableVariable],
      value: [{ page_id: 1, tableData: _newTable }],
    };

    _setAllVariables({ ..._allVariables });
    _setVariables(_variables);
  };

  const onClose = () => {
    setValidationCheck(false);
    setEmptyFields([]);
    setOpen(false);
    // setUserDropDown([...[]]);
    // setDefaultUserDropDown([...[]]);
    _setVariables({});
    _setAllVariables({});
    _setUrls([]);
    _setTableData([]);
    _setTableColumns([]);
    setTableVariable();
  };

  const collectEditRequirements = (obj) => {
    setIsOnHold(false);
    if (obj.status == "hold") {
      setIsOnHold(true);
    }
    setIsOpeningDrawer(true);
    checkIsAdmin(obj);
    dispatch(getAutomationBuild(obj.build_id));
    showDrawer(obj);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (record) => {
    confirm({
      title: "Are you sure delete this row?",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteInvoice(record);
      },
      onCancel() {},
    });
  };
  const deleteInvoice = async (obj) => {
    const resultResponse = await dispatch(removeApprovalTask(obj.id));
    if (resultResponse?.status) {
      dispatch(notify("success", "Task removed successfully"));
      dispatch(getAllApprovals());
    } else dispatch(notify("error", "Task removal failed"));
  };

  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      width: 60,
    },
    {
      title: "approvers",
      dataIndex: "approvers",
      key: "approvers",
      width: 350,
      render: (_, { approvers }) => (
        <>
          {approvers.list.map((approver, i) => (
            <div key={i} style={{ marginTop: 20, marginBottom: 20 }}>
              <h6 style={{ fontSize: 12, fontWeight: 400 }}>
                {approver}
                <span
                  style={{
                    marginLeft: 15,
                    fontSize: 10,
                    fontWeight: 100,
                    border: "1px solid #d9d9d9",
                    background: "rgba(0,0,0,.02)",
                    padding: "3px 6px",
                    borderRadius: 3,
                  }}
                >
                  {approvers?.meta?.[approver] == undefined ||
                  approvers?.meta?.[approver] == null ? (
                    <>
                      <ClockCircleOutlined /> Pending
                    </>
                  ) : approvers?.meta?.[approver] == true ? (
                    <>
                      <CheckOutlined /> Approved
                    </>
                  ) : (
                    <>
                      <CloseOutlined /> Rejected
                    </>
                  )}
                </span>
              </h6>
            </div>
          ))}
        </>
      ),
    },

    {
      title: "status",
      key: "status",
      dataIndex: "status",
      // width: 150,
      filters: [
        {
          text: "Approved",
          value: "approved",
          color: "blue",
        },

        {
          text: "Processed",
          value: "processed",
          color: "cyan",
        },

        {
          text: "Failed",
          value: "failed",
          color: "error",
        },

        {
          text: "Rejected",
          value: "rejected",
          color: "error",
        },
        {
          text: "In-Progress",
          value: "incomplete",
          color: "volcano",
        },
        {
          text: "Hold",
          value: "hold",
          color: "volcano",
        },
      ],
      filterMultiple: false,
      filteredValue: filters,
      onFilter: (value, record) => record.status.includes(value),
      render: (_, { status, approvers }) => (
        <>
          <Tag
            className={
              status === "approved"
                ? "tag-approve"
                : status === "rejected"
                ? "tag-rejected"
                : "tag-incomplete"
            }
          >
            {status == "incomplete" ? "in-progress" : status}
          </Tag>
        </>
      ),
    },

    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
      render: (_, { invoice_no }) => <>{invoice_no}</>,
    },

    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      render: (_, { invoice_date }) => <>{invoice_date}</>,
    },

    {
      title: "Vendor name",
      dataIndex: "vendor_name",
      key: "vendor_name",
      render: (_, { vendor_name }) => <>{vendor_name}</>,
    },

    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   key: "remarks",
    // },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, obj) => {
        return (
          <>
            <Space size="middle" style={{ gap: "3px" }}>
              <Button
                className="btn btn-primary btn-sm"
                style={{ color: "#fff", fontSize: 12 }}
                onClick={() => collectEditRequirements(obj)}
                disabled={
                  !(
                    (userRole?.id ==
                      obj?.automation_build?.draft_skill?.organizationId &&
                      userRole?.isAdmin) ||
                    currentUser?.role_id == "2"
                  ) && obj.status == "hold"
                }
              >
                <EditOutlined /> Edit
              </Button>
              {(userRole?.id ==
                obj?.automation_build?.draft_skill?.organizationId &&
                userRole?.isAdmin) ||
              currentUser?.role_id == "2" ? (
                <Tooltip title="Delete">
                  <Button
                    type="danger"
                    shape="circle"
                    icon={<DeleteOutlined />}
                    onClick={() => showDeleteConfirm(obj)}
                  />
                </Tooltip>
              ) : null}
            </Space>
          </>
        );
      },
    },
  ];

  const approve = async () => {
    setIsApproving(true);
    let allRemarks;
    if (Object.keys(newRemarks).length === 0) {
      let _res = addRemarks();
      _res["status"] = "Approved";

      allRemarks = [...remarks, _res];
    } else {
      newRemarks["status"] = "Approved";

      allRemarks = [...remarks, newRemarks];
    }
    await dispatch(
      updateApproval(
        _currentApproval.id,
        "approved",
        allRemarks,
        _allVariables,
        null
      )
    );
    await dispatch(getAllApprovals());
    dispatch(notify("success", "Updated Successfully"));
    setIsApproving(false);
    setOverRideUser("");
    setReviewText("");
    setNewRemarks("");
    setUserDropDown([]);
    setDefaultUserDropDown([]);
    onClose();
  };

  const handleApprovalModalOk = async () => {
    setIsApproving(true);
    setIsModalOpen(false);
    let allRemarks;
    let dynamicApprovalOptions = null;
    let _overrideUserOptions = null;
    if (overRideUser !== "") {
      _overrideUserOptions = overRideUser;
    }
    if (Object.keys(newRemarks).length === 0) {
      let _res = addRemarks();
      _res["status"] = "Approved";

      allRemarks = [...remarks, _res];
    } else {
      newRemarks["status"] = "Approved";
      allRemarks = [...remarks, newRemarks];
    }

    if (
      JSON.stringify(_currentApproval?.approvers?.list) ==
      JSON.stringify(defaultuserDropDown)
    ) {
      dynamicApprovalOptions = null;
    } else {
      dynamicApprovalOptions = defaultuserDropDown;
    }
    await dispatch(
      updateApproval(
        _currentApproval.id,
        "approved",
        allRemarks,
        _allVariables,
        _overrideUserOptions,
        dynamicApprovalOptions
      )
    );
    setIsDynamicModalOpen(false);

    await dispatch(getAllApprovals());
    setIsApproving(false);
    dispatch(notify("success", "Updated Successfully"));
    setOverRideUser("");
    setReviewText("");
    setNewRemarks("");
    setUserDropDown([]);
    setDefaultUserDropDown([]);
    onClose();
  };

  const handleApprovalModal = async () => {
    let lastUser =
      _currentApproval.approvers.list[
        _currentApproval.approvers.list.length - 1
      ];
    let isLastUser = lastUser == user.email;
    let emptyFields = Object.values(_variables).filter(
      (i) => i["value"] === ""
    );
    if (emptyFields.length > 0) {
      setEmptyFields(emptyFields);
      setValidationCheck(false);
    } else {
      setValidationCheck(true);
    }
    if (_currentApproval.approvers.kind == "serial" && isLastUser) {
      setIsDynamicModalOpen(true);
    } else {
      approve();
    }
  };

  const handleApprovalModalAdmin = async () => {
    setDefaultUserDropDown([]);
    let list = _currentApproval.approvers.list;
    list.push(currentUser?.email);
    let usersApprovedCount = Object.keys(
      _currentApproval.approvers.meta
    ).filter((i) => _currentApproval.approvers.meta[i]);
    let pendingCount = list.length - usersApprovedCount.length;
    let emptyFields = Object.values(_variables).filter(
      (i) => i["value"] === ""
    );
    if (emptyFields.length > 0) {
      setEmptyFields(emptyFields);
      setValidationCheck(false);
    } else {
      setValidationCheck(true);
    }
    if (
      (_currentApproval.approvers.kind == "serial" && pendingCount == 1) ||
      currentUser?.role_id == "2"
    ) {
      setOverRideUser(list[list.length - 1]);
      showModal(true);
    } else {
      showModal(false);
    }
  };

  const reject = async () => {
    if (reviewText?.length > 0) {
      let allRemarks;
      if (Object.keys(newRemarks).length === 0) {
        let _res = addRemarks();
        _res["status"] = "Rejected";
        allRemarks = [...remarks, _res];
      } else {
        newRemarks["status"] = "Rejected";
        allRemarks = [...remarks, newRemarks];
      }
      setIsRejecting(true);
      await dispatch(
        updateApproval(
          _currentApproval.id,
          "rejected",
          allRemarks,
          _allVariables,
          null
        )
      );
      await dispatch(getAllApprovals());
      dispatch(notify("success", "Updated Successfully"));
      setIsRejecting(false);
      setOverRideUser("");
      setReviewText("");
      setNewRemarks("");
      setUserDropDown([]);
      setDefaultUserDropDown([]);
      setIsRejectUserModalOpen(false);
      onClose();
    } else {
      dispatch(
        notify("error", "Remarks field cannot be empty while rejecting")
      );
    }
  };

  const hold = async () => {
    await dispatch(setOnHold(_currentApproval.id, isOnHold));
    onClose();
    history.push("/dashboard/approvals");
  };

  const handleChange = (pagination, filters, sorter) => {
    const queryParams = new URLSearchParams(location.search);
    setFilters(filters.status);
    dispatch(getAllApprovals({ filters }));
  };

  const updateTable = async (e, column, key) => {
    const { value: inputValue } = e.target;
    const _newTable = await _tableData.map((item, index) => {
      if (item.key == key) {
        let _obj = {};
        _obj[column] = inputValue;
        return { ...item, ..._obj };
      } else {
        return item;
      }
    });

    _allVariables[tableVariable] = {
      ..._allVariables[tableVariable],
      value: [{ page_id: 1, tableData: _newTable }],
    };
    _setAllVariables({ ..._allVariables });
    _setTableData(_newTable);
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const formatData = async (parsedDates) => {
    setIsLoadingStats(true);
    let _isAdmin = userRole?.isAdmin;
    let result;
    if (parsedDates) {
      let _start = parsedDates
        ? moment(parsedDates[0]).format("YYYY-MM-DD HH:mm:ss")
        : moment(dates[0]).format("YYYY-MM-DD HH:mm:ss");
      let _endDate = parsedDates
        ? moment(parsedDates[1]).format("YYYY-MM-DD HH:mm:ss")
        : moment(dates[1]).format("YYYY-MM-DD HH:mm:ss");
      result = await dispatch(getApprovalStats(_start, _endDate, _isAdmin));
    } else {
      result = await dispatch(getApprovalStats(null, null, _isAdmin));
    }

    setIsLoadingStats(false);

    if (result?.status == "success") {
      if (result?.response?.count?.length) {
        result?.response?.count.map((ele) => {
          if (ele.status == "approved") {
            setApprovedCount(ele.count);
          }
          if (ele.status == "rejected") {
            setRejectedCount(ele.count);
          }
          if (ele.status == "incomplete") {
            setInProgressCount(ele.count);
          }
        });
      } else {
        setApprovedCount(0);
        setRejectedCount(0);
        setInProgressCount(0);
      }
    } else {
      setIsLoadingStats(false);

      setApprovedCount(0);
      setRejectedCount(0);
      setInProgressCount(0);
    }
  };
  const formatQuery = (queryName, queryValue) => {
    queryName = queryName.toLowerCase();
    if (queryName?.includes(" ")) {
      queryName = queryName.replace(/ /g, "_");
    }

    dispatch(
      getAllApprovals(null, {
        search: {
          queryName,
          queryValue,
        },
      })
    );
  };

  const resetQuery = () => {
    setQueryValue("");
    setQueryName("");
    dispatch(getAllApprovals());
  };

  const showModal = (dynamic = false) => {
    if (dynamic) {
      setIsDynamicModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };

  const showRejectModal = () => {
    setIsRejectModalOpen(true);
  };
  const handleOk = async () => {
    if (overRideUser !== "") {
      setIsApproving(true);
      setIsModalOpen(false);
      let allRemarks;

      if (Object.keys(newRemarks).length === 0) {
        let _res = addRemarks();
        _res["status"] = "Approved";
        allRemarks = [...remarks, _res];
      } else {
        newRemarks["status"] = "Approved";
        allRemarks = [...remarks, newRemarks];
      }
      await dispatch(
        updateApproval(
          _currentApproval.id,
          "approved",
          allRemarks,
          _allVariables,
          overRideUser
        )
      );
      await dispatch(getAllApprovals());
      setIsApproving(false);

      dispatch(notify("success", "Updated Successfully"));
      setOverRideUser("");
      setReviewText("");
      setNewRemarks("");
      setUserDropDown([]);
      setDefaultUserDropDown([]);
      onClose();
    } else {
      setIsApproving(false);

      dispatch(notify("error", "Please select user from dropdown"));
    }
  };

  const handleCancel = (dynamic = false) => {
    if (dynamic) {
      setIsDynamicModalOpen(false);
      setOverRideUser(null);
      // setUserDropDown([]);
      // setDefaultUserDropDown([]);
    } else {
      setIsModalOpen(false);
      setOverRideUser(null);
    }
    setValidationCheck(false);
  };
  const handleCancelReject = () => {
    setIsRejectModalOpen(false);
    setOverRideUser("");
  };
  const handleReject = async () => {
    if (reviewText?.length > 0) {
      if (overRideUser !== "") {
        setIsRejecting(true);
        setIsRejectModalOpen(false);
        let allRemarks;
        if (Object.keys(newRemarks).length === 0) {
          let _res = addRemarks();
          _res["status"] = "Rejected";
          allRemarks = [...remarks, _res];
        } else {
          newRemarks["status"] = "Rejected";

          allRemarks = [...remarks, newRemarks];
        }
        await dispatch(
          updateApproval(
            _currentApproval.id,
            "rejected",
            allRemarks,
            _allVariables,
            overRideUser
          )
        );
        await dispatch(getAllApprovals());
        setIsRejecting(false);
        dispatch(notify("success", "Updated Successfully"));
        setOverRideUser("");
        setReviewText("");
        setNewRemarks("");
        onClose();
      } else {
        setIsRejecting(false);

        dispatch(notify("error", "Please select user from dropdown"));
      }
    } else {
      dispatch(
        notify("error", "Remarks field cannot be empty while rejecting")
      );
    }
  };
  const onRadioChange = (e) => {
    setAdminAction(e.target.value);
    let _approverlist = [];
    if (_currentApproval?.approvers?.kind == "serial") {
      let _tempMeta = Object.keys(_currentApproval?.approvers?.meta);
      _tempMeta.map((item) => {
        if (!_currentApproval?.approvers?.meta[item]) {
          let _obj = {
            label: item,
            value: item,
          };
          _approverlist.push(_obj);
        }
      });
    } else {
      _currentApproval?.approvers?.list?.map((a) => {
        if (!_currentApproval?.approvers?.meta.hasOwnProperty(a)) {
          let _obj = {
            label: a,
            value: a,
          };
          _approverlist.push(_obj);
        }
      });
    }

    setOverRideOptions(_approverlist);
  };

  const onOverRideChange = (value) => {
    setOverRideUser(value);
  };

  const showUserRejectModal = () => {
    setIsRejectUserModalOpen(true);
  };
  const handleUserCancelReject = () => {
    setIsRejectUserModalOpen(false);
  };
  const handleReset = async () => {
    let allRemarks;
    if (Object.keys(newRemarks).length === 0) {
      let _res = addRemarks();
      _res["status"] = "Reset";
      allRemarks = [...remarks, _res];
    } else {
      newRemarks["status"] = "Reset";

      allRemarks = [...remarks, newRemarks];
    }
    setIsReseting(true);
    await dispatch(resetApproval(_currentApproval.id, allRemarks));
    await dispatch(getAllApprovals());
    onClose();
    setIsReseting(false);
    setIsRejectUserModalOpen(false);
    setIsRejectModalOpen(false);
  };

  const addRemarks = (r) => {
    setReviewText(r);
    if (r == "" || r == undefined) {
      let _date = moment(new Date());
      let _newRemarks = {
        email: user?.email,
        remarks: "",
        updateAt: _date._d,
      };

      setNewRemarks(_newRemarks);
      return _newRemarks;
    } else {
      let _date = moment(new Date());
      let _newRemarks = {
        email: user?.email,
        remarks: r,
        updateAt: _date._d,
      };

      setNewRemarks(_newRemarks);
      return _newRemarks;
    }
  };

  const save = async () => {
    setIsSaving(true);
    await dispatch(saveApproval(_currentApproval.id, _allVariables));

    setIsSaving(false);
  };
  return (
    <React.Fragment>
      {isLoadingApprovalList || isLoadingStats ? (
        <Loader
          styles={{ width: "80px", margin: "auto" }}
          root={{ display: "flex" }}
        />
      ) : (
        <div className="template-flex">
          <div className="template-box scrollable">
            <div class="tp-title flex-title">
              <h3>Approval Task</h3>
            </div>

            {/* statistic */}
            <div className="stats-block">
              <div className="stats-range">
                <RangePicker
                  value={dates || value}
                  onChange={(val) => {
                    setValue(val);
                  }}
                  onCalendarChange={(val) => {
                    setDates(val);
                  }}
                  onOpenChange={onOpenChange}
                  changeOnBlur
                />
                <Button
                  className="btn btn-primary btn-sm"
                  shape="circle"
                  icon={
                    isLoadingStats ? (
                      <div class="sp sp-circle text-light"></div>
                    ) : (
                      <SearchOutlined />
                    )
                  }
                  style={{ color: "#fff", fontSize: 12 }}
                  onClick={() => formatData(value)}
                />
              </div>
              <Row gutter={12}>
                <Col span={6}>
                  <Card bordered={false}>
                    <div className="stats-icon">
                      <img src={statsApproved} />
                    </div>
                    <Statistic
                      title="Approved"
                      value={approvedCount}
                      valueStyle={{
                        color: "#02ce9d",
                      }}
                      // prefix={<ArrowUpOutlined />}
                      // suffix="%"
                    />
                  </Card>
                </Col>
                <Col span={6}>
                  <Card bordered={false}>
                    <div className="stats-icon">
                      <img src={statsInProgress} />
                    </div>
                    <Statistic
                      title="In-Progress"
                      value={inProgressCount}
                      valueStyle={{
                        color: "#d46b08",
                      }}
                      // prefix={<ArrowDownOutlined />}
                      // suffix="%"
                    />
                  </Card>
                </Col>
                <Col span={6}>
                  <Card bordered={false}>
                    <div className="stats-icon">
                      <img src={statsRejected} />
                    </div>
                    <Statistic
                      title="Rejected"
                      value={rejectedCount}
                      valueStyle={{
                        color: "#ff3000",
                      }}
                      // prefix={<ArrowDownOutlined />}
                      // suffix="%"
                    />
                  </Card>
                </Col>
              </Row>
            </div>
            {/* End of statistic */}

            <h4> Filters </h4>
            <div
              style={{
                width: "50%",
                justifyContent: "space-between",
                display: "flex",
                marginBottom: 10,
              }}
            >
              <AutoComplete
                style={{
                  width: 150,
                }}
                options={options}
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={(e) => setQueryName(e)}
                value={queryName}
              />

              {/* <Input
                style={{ width: 150 }}
                onChange={(e) => setQueryName(e.target.value)}
              ></Input> */}
              <Select
                defaultValue="eq"
                style={{ width: 120 }}
                // onChange={handleChange}
                options={[{ value: "=", label: "eq" }]}
              />
              <Input
                style={{ width: 150 }}
                onChange={(e) => setQueryValue(e.target.value)}
                value={queryValue}
              ></Input>
              <Button onClick={() => formatQuery(queryName, queryValue)}>
                Search
              </Button>
              <Button onClick={() => resetQuery()}>Reset</Button>
            </div>
            <Table
              columns={columns}
              dataSource={_approvals}
              rowKey={(record) => record.id}
              pagination={false}
              onChange={handleChange}
              // scroll={{
              //   y: "80vh",
              // }}
              // expandable={{
              //   expandedRowRender: (record) => (
              //     <p
              //     >
              //       {"record"}
              //     </p>
              //   ),
              //   rowExpandable: (record) => record.id %2 == 0,
              // }}
            />

            <Drawer
              title="Approval"
              placement={"right"}
              width={"100%"}
              onClose={onClose}
              closeIcon={null}
              open={open}
              extra={
                <Space>
                  <Button className="btn btn-outline" onClick={onClose}>
                    Cancel
                  </Button>
                  {isSaving ? (
                    <Button className="btn btn-outline">
                      <div class="sp sp-circle text-light"></div>
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-outline"
                      onClick={save}
                      disabled={automationBuildLog?.status == "completed"}
                    >
                      Save
                    </Button>
                  )}
                  {isAdmin ? (
                    <>
                      {isApproving ? (
                        <Button type="primary">
                          <div class="sp sp-circle text-light"></div>
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          onClick={() => handleApprovalModalAdmin()}
                          disabled={overRideOptions?.length > 0 ? false : true}
                        >
                          Approve
                        </Button>
                      )}
                      {isRejecting ? (
                        <Button type="danger">
                          <div class="sp sp-circle text-light"></div>
                        </Button>
                      ) : (
                        <Button
                          type="danger"
                          onClick={showRejectModal}
                          // disabled={overRideOptions.length > 0 ? false : true}
                        >
                          Reject
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {isApproving ? (
                        <Button type="primary">
                          <div class="sp sp-circle text-light"></div>
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          disabled={buttonDisabled}
                          // onClick={() => {_currentApproval?.approvers?.kind == "serial" ? showModal(true) : showModal(false)}}
                          // onClick={approve}
                          onClick={handleApprovalModal}
                        >
                          Approve
                        </Button>
                      )}

                      {isRejecting ? (
                        <Button type="danger">
                          <div class="sp sp-circle text-light"></div>
                        </Button>
                      ) : (
                        <Button
                          type="danger"
                          // onClick={reject}
                          onClick={showUserRejectModal}
                          disabled={buttonDisabled}
                        >
                          Reject
                        </Button>
                      )}
                    </>
                  )}
                  {isAdmin ? (
                    <Button
                      type="danger"
                      onClick={hold}
                      disabled={overRideOptions?.length > 0 ? false : true}
                    >
                      {isOnHold ? "Unhold" : "Hold"}
                    </Button>
                  ) : null}
                </Space>
              }
            >
              <div className="container-fluid">
                <h3 className="apb-title">Build Summary </h3>

                <div className="row apb-row">
                  {_urls.length > 0 &&
                    _urls.map((id, index) => {
                      return (
                        <div className="col-md-6">
                          <div key={index} style={{ height: "100%" }}>
                            <iframe
                              title="PDF Viewer"
                              src={_urls[index]}
                              width="100%"
                              height="100%"
                              frameBorder="0"
                            />
                          </div>
                        </div>
                      );
                    })}

                  <div className="col-md-6 apb-bg-block">
                    <div style={{ marginBottom: 20, position: "relative" }}>
                      <Button type="primary" onClick={() => showDialog(true)}>
                        Add +
                      </Button>

                      {dialog ? (
                        <div
                          style={{
                            position: "absolute",
                            width: 400,
                            minHeight: 150,
                            zIndex: 1,
                            borderRadius: "1rem",
                            boxShadow: "1px 1px 4px #eee",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            marginTop: 5,
                            padding: "10px 30px",
                          }}
                        >
                          <div style={{ marginTop: 10 }}>
                            <label style={{ fontSize: 12 }}> Name</label>
                            <Input
                              style={{ fontSize: 12 }}
                              value={varName}
                              onChange={(e) => setVarName(e.target.value)}
                            ></Input>
                          </div>

                          <div style={{ marginTop: 10 }}>
                            <label style={{ fontSize: 12 }}> Value</label>
                            <Input
                              style={{ fontSize: 12 }}
                              value={varValue}
                              onChange={(e) => setVarValue(e.target.value)}
                            ></Input>
                          </div>

                          <div style={{ marginTop: 20 }}>
                            <Button
                              type="default"
                              onClick={() => {
                                setVarName("");
                                setVarValue("");
                                showDialog(false);
                              }}
                            >
                              Close
                            </Button>
                            <Button
                              type="primary"
                              onClick={() => {
                                addVariable();
                                setVarName("");
                                setVarValue("");
                                showDialog(false);
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </div>

                    {Object.keys(_variables || [])
                      .sort(
                        (a, b) =>
                          _variables[a]?.sequence - _variables[b]?.sequence
                      )
                      .map((i, index) => {
                        return (
                          <div key={`var-${index}`}>
                            <div className="apb-input-block">
                              {_variables[i]["name"].includes("_") ? (
                                <label>
                                  {_variables[i]["type"] == "dataTable" ? (
                                    <label>
                                      {_variables[i]["value"][0][0]}
                                    </label>
                                  ) : (
                                    _variables[i]["name"].replace(/_/g, " ")
                                  )}
                                </label>
                              ) : _variables[i]["type"] == "dataTable" ? (
                                <label>{_variables[i]["value"][0][0]}</label>
                              ) : (
                                <label>{_variables[i]["name"]}</label>
                              )}

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {_variables[i]["type"] == "list" ||
                                _variables[i]["type"] == "dataTable" ? (
                                  _variables[i]["type"] == "dataTable" ? (
                                    <>
                                    <div
                                      className="select-input"
                                      style={{
                                        display: "flex",
                                        gap: "15px",
                                        width: "92%",
                                      }}
                                    >
                                      <Select
                                        virtual={false}
                                        style={{ width: 500 }}
                                        value={_variables[i]["defaultValue"]}
                                        defaultValue={_variables[i]["value"][0]}
                                        showSearch
                                        onChange={(e) =>
                                          variableOnChangeDataTable(
                                            e,
                                            _variables[i]["value"],
                                            _variables[i]["id"],
                                            true
                                          )
                                        }
                                        options={_variables[i]["value"].map(
                                          (i, index) => {
                                            if (index != 0) {
                                              return {
                                                value: i[0],
                                                label: i[0],
                                              };
                                            } else {
                                              return {
                                                value: null,
                                                label: null,
                                              };
                                            }
                                          }
                                        )}
                                      />
                                      {/* <Input placeholder="Write your own value" /> */}
                                      {/* <Button style={{padding: '0px'}} type="primary" shape="circle" icon={<PlusOutlined />} /> */}
                                      <div className="dropdown-values" style={{position: 'relative'}}>
                                        {currentUser?.role_id == "2" ? (
                                          <Button
                                            type="primary"
                                            style={{padding: '4px', width: '30px'}}
                                            onClick={() => showDialogOne(true)}
                                          >
                                            <PlusOutlined />
                                          </Button>
                                        ) : null}

                                        {dialogOne ? (
                                          <div
                                            style={{
                                              position: "absolute",
                                              width: 400,
                                              minHeight: 150,
                                              zIndex: 1,
                                              borderRadius: "1rem",
                                              boxShadow: "1px 1px 4px #eee",
                                              backgroundColor: "#fff",
                                              border: "1px solid #ddd",
                                              marginTop: 5,
                                              padding: "10px 30px",
                                              right: 0,
                                              bottom: "40px"
                                            }}
                                          >
                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>Name</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={nameValue}
                                              onChange={(e) => setNameValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>BP Code</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={BPCodeValue}
                                              onChange={(e) => setBPCodeValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>GL Code</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={GLCodeValue}
                                              onChange={(e) => setGLCodeValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>GL Account Name</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={GLAccountNameValue}
                                              onChange={(e) => setGLAccountNameValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>Dept</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={deptValue}
                                              onChange={(e) => setDeptValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>Div</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={divValue}
                                              onChange={(e) => setDivValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 10 }}>
                                              <label style={{ fontSize: 12 }}>Project Code</label>
                                              <Input style={{ fontSize: 12 }}
                                              value={projectCodeValue}
                                              onChange={(e) => setProjectCodeValue(e.target.value)}
                                              >
                                              </Input>
                                            </div>

                                            <div style={{ marginTop: 20 }}>
                                              <Button
                                                type="default"
                                                onClick={() => {
                                                  showDialogOne(false);
                                                }}
                                              >
                                                Close
                                              </Button>
                                              <Button
                                                type="primary"
                                                onClick={() => {
                                                  if(nameValue?.length < 1)
                                                    dispatch(notify("error", "Name is mandatory"))
                                                  else if(BPCodeValue?.length < 1)
                                                    dispatch(notify("error", "BP Code is mandatory"))
                                                  else {

                                                    const dropdownObject = {
                                                      nameValue,
                                                      BPCodeValue,
                                                      GLCodeValue,
                                                      GLAccountNameValue,
                                                      deptValue,
                                                      divValue,
                                                      projectCodeValue
                                                    }

                                                    let tempArray = Object.values(dropdownObject);
                                                    tempArray[0] = `${dropdownObject.nameValue}_${dropdownObject.BPCodeValue}_${dropdownObject.GLCodeValue}`;

                                                    _variables[i]["value"].push(Object.values(tempArray))
                                                    dispatch(saveDropdownList(dropdownObject))
                                                    showDialogOne(false);

                                                    setNameValue("")
                                                    setBPCodeValue("")
                                                    setGLAccountNameValue("")
                                                    setGLCodeValue("")
                                                    setDeptValue("")
                                                    setDivValue("")
                                                    setProjectCodeValue("")

                                                    dispatch(getAllApprovals());
                                                    
                                                  }
                                                }}
                                              >
                                                Save
                                              </Button>
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                     
                                   
                                    </>
                                  ) : (
                                    <Select
                                      virtual={false}
                                      style={{ width: 300 }}
                                      value={_variables[i]["defaultValue"]}
                                      defaultValue={_variables[i]["value"][0]}
                                      onChange={(e) =>
                                        variableOnChange(
                                          e,
                                          _variables[i]["id"],
                                          true
                                        )
                                      }
                                      options={_variables[i]["value"].map(
                                        (i) => {
                                          return { value: i, label: i };
                                        }
                                      )}
                                    />
                                  )
                                ) : (
                                  <>
                                  {_variables[i]["name"] == "invoice_due_date" || _variables[i]["name"] == "invoice_date" ? (
                                      <>
                                       <DatePicker
                                                  allowClear={false}
                                                  format="MMM DD, YYYY"
                                                  value={_variables[i]["value"]?.length > 0 ? (_variables[i]["name"] == "invoice_due_date" ? moment(_variables[i]["value"], "MMM DD, YYYY") : moment(_variables[i]["value"], "MM/DD/YY")) : null}
                                                  placeholder="Select Date"
                                                  onChange={(date) => variableOnChangeDateSelected(date, _variables[i]["id"], _variables[i]["name"])
                                                  }
                                                />
                                    </>
                                    ):(
                                    <>
                                  <Input
                                    value={_variables[i]["value"]}
                                    defaultValue={_variables[i]["value"]}
                                    onChange={(e) =>
                                      variableOnChange(e, _variables[i]["id"])
                                    }
                                  />
                                    </>
                                    )}
                                  </>
                                )}

                                <DeleteTwoTone
                                  onClick={() =>
                                    removeVariable(_variables[i]["id"])
                                  }
                                />
                              </div>
                            </div>

                            {_variables[i]["type"] == "dataTable" ? (
                              <div className="apb-input-block">
                              <label>GL Code</label>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                 
                                <Select
                                          virtual={false}
                                          style={{ width: 500 }}
                                          value={_variables[i].gl_code}
                                          showSearch
                                          onChange={(e) =>{
                                            glCodeOnChangeDataTable(
                                              e,
                                              _variables[i]["id"]
                                            )
                                          }
                                          }
                                          options={glDropdownList?.map(
                                            (i, index) => {
                                                return {
                                                  value: i?.name,
                                                  label: i?.name,
                                                };
                                            }
                                          )}
                                />
                                </div>
                              </div>
                              ) : null
                            }
                          </div>
                        );
                      })}
                  </div>
                </div>

                <div className="table-approval">
                  {_tableData.length > 0 && showTable ? (
                    <>
                      <Button
                        onClick={addTableRow}
                        type="primary"
                        style={{
                          marginBottom: 16,
                        }}
                      >
                        Add a row
                      </Button>
                      <Table
                        className="approval-ant-table"
                        summary={(pageData) => {
                          let totalAmount = "0.00";
                          pageData.forEach(({ Amount }) => {
                            let _ammount = Amount.replace(/,/g, "");
                            totalAmount = String(
                              (
                                parseFloat(totalAmount) + parseFloat(_ammount)
                              ).toFixed(2)
                            );
                          });

                          return (
                            <>
                              <Table.Summary.Row>
                                <Table.Summary.Cell index={0}>
                                  Total Amount
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1} colSpan={2}>
                                  <Text type="success">{totalAmount}</Text>
                                </Table.Summary.Cell>
                              </Table.Summary.Row>
                            </>
                          );
                        }}
                        expandable={{
                          expandedRowRender: (record) => {
                            return (
                              <div style={{ margin: "20px 0px" }}>
                                {Object.keys(record)
                                  .filter((i) => i != "key")
                                  .map((i, index) => {
                                    return (
                                      <div
                                        className="apb-input-block"
                                        style={{
                                          margin: "10px 20px",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <label style={{ fontSize: 12 }}>
                                          {i}
                                        </label>
                                        <Input
                                          placeholder="Input a number"
                                          defaultValue={record[i]}
                                          style={{
                                            maxWidth: 300,
                                          }}
                                          size="small"
                                          onChange={(e) =>
                                            updateTable(e, i, record.key)
                                          }
                                        ></Input>
                                      </div>
                                    );
                                  })}

                                <Popconfirm
                                  title="Sure to delete?"
                                  onConfirm={() => handleDelete(record)}
                                >
                                  <a>Delete</a>
                                </Popconfirm>
                              </div>
                            );
                          },
                        }}
                        columns={_tableColumns}
                        dataSource={_tableData}
                        size="small"
                        pagination={false}
                        scroll={{
                          x: 1300,
                        }}
                      />
                    </>
                  ) : showTable == false ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 100,
                      }}
                    >
                      <LoadingOutlined spin={true} />
                    </div>
                  ) : null}
                </div>

                {/* <hr /> */}

                {/* Remarks table */}

                <div className="row remarks-block">
                  <div className="col-md-12">
                    <h4>Remarks</h4>
                    <TextArea
                      value={reviewText}
                      showCount
                      maxLength={100}
                      style={{ height: 120, marginBottom: 24, width: 500 }}
                      placeholder="Add some review comments"
                      onChange={(e) => addRemarks(e.target.value)}
                    />
                  </div>
                  {_remarksData && _remarksColumns ? (
                    <div className="table-approval">
                      <Table
                        className="approval-ant-table"
                        columns={_remarksColumns}
                        dataSource={_remarksData}
                        size="small"
                        pagination={false}
                        scroll={{
                          x: 1300,
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </Drawer>

            {/* Admin OverRide Approve Modal */}
            <Modal
              title="Approve"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={() => handleCancel(false)}
              okText={"Approve"}
              okType="primary"
              okButtonProps={{
                disabled: !validationCheck,
              }}
            >
              <div
                className={
                  validationCheck
                    ? "modal-body-center"
                    : "modal-body-center blurred"
                }
              >
                <Select
                  value={overRideUser}
                  style={{ width: 200 }}
                  placeholder="Select approver to approve"
                  optionFilterProp="children"
                  onChange={onOverRideChange}
                  options={overRideOptions}
                />
              </div>

              {!validationCheck ? (
                <div className="validation-check">
                  <p style={{ textAlign: "center" }}> Few fields are empty </p>
                  <p style={{ textAlign: "center" }}>
                    {emptyFields.map((i) => i.name.replace("_", " ")).join(",")}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      type="link"
                      danger
                      onClick={() => handleCancel(true)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="link"
                      onClick={() => setValidationCheck(true)}
                    >
                      {" "}
                      Proceed anyway{" "}
                    </Button>
                  </div>
                </div>
              ) : null}
            </Modal>

            <Modal
              title="Approve"
              open={isDynamicModalOpen}
              onOk={handleApprovalModalOk}
              onCancel={() => handleCancel(true)}
              okText={"Approve"}
              okType="primary"
              okButtonProps={{
                disabled: !validationCheck,
              }}
            >
              <div
                className={
                  validationCheck
                    ? "modal-body-center"
                    : "modal-body-center blurred"
                }
              >
                <p>Add further reviewers incase task is critical</p>
                <Select
                  mode="multiple"
                  placeholder="Please select"
                  onChange={(e) => {
                    setDefaultUserDropDown([...e]);
                  }}
                  style={{ width: "100%" }}
                  options={userDropDown}
                />
              </div>

              {!validationCheck ? (
                <div className="validation-check">
                  <p style={{ textAlign: "center" }}> Few fields are empty </p>
                  <p style={{ textAlign: "center" }}>
                    {emptyFields.map((i) => i.name.replace("_", " ")).join(",")}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      type="link"
                      danger
                      onClick={() => handleCancel(true)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="link"
                      onClick={() => setValidationCheck(true)}
                    >
                      Proceed anyway
                    </Button>
                  </div>
                </div>
              ) : null}
            </Modal>

            {/* Admin OverrIDE Reject Modal */}

            <Modal
              title="Reject"
              open={isRejectModalOpen}
              onOk={handleReject}
              onCancel={handleCancelReject}
              okText={"Reject"}
              okType="danger"
              footer={[
                <Button
                  key="reset"
                  type="primary"
                  loading={reseting}
                  onClick={handleReset}
                >
                  Reset
                </Button>,
                <Button key="reject" type="danger" onClick={handleReject}>
                  Reject
                </Button>,
                <Button key="cancel" onClick={handleCancelReject}>
                  Cancel
                </Button>,
              ]}
            >
              <div className="modal-body-center">
                <Select
                  value={overRideUser}
                  style={{ width: 200 }}
                  placeholder="Select approver to approve"
                  optionFilterProp="children"
                  onChange={onOverRideChange}
                  options={overRideOptions}
                />
              </div>
            </Modal>
            {/* User Reject or Reset Modal */}
            <Modal
              title="Reject/Reset"
              open={isRejectUserModalOpen}
              onOk={reject}
              onCancel={handleUserCancelReject}
              okText={"Reject"}
              okType="danger"
              footer={[
                <Button
                  key="reset"
                  type="primary"
                  loading={reseting}
                  onClick={handleReset}
                >
                  Reset
                </Button>,
                <Button key="reject" type="danger" onClick={reject}>
                  Reject
                </Button>,
                <Button key="cancel" onClick={handleUserCancelReject}>
                  Cancel
                </Button>,
              ]}
            >
              <div className="modal-body-center">
                <p>You can reject/reset the approval.</p>
              </div>
            </Modal>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Approval;
